"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateSampleRate = calculateSampleRate;
function calculateSampleRate(receivedFps, storedFps) {
  if (storedFps === 0) {
    return 0; // don't divide by zero
  }
  var sampleRate = receivedFps / storedFps;
  if (sampleRate > 1 && sampleRate < 1.1) {
    return 1;
  }
  return Math.round(sampleRate * 10) / 10;
}